'use strict';

/**
 * View for rendering a single set
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var ShareSetLayout = require('../layout/share-set-overlay');
var RestrictionModalView = require('modules/base/views/layout/restriction-sets-modal');
var SetModel = require('../../models/set');

var template = require('modules/collection/modules/set/templates/partials/list-item.hbs');

var ListItemView = ItemView.extend({
    template: template,

    wrapItem: false,

    displayImage: true,

    viewData: {
        displayImage: function() {
            return this.getOption('displayImage');
        },

        isShared: function() {
            return this.model instanceof SetModel && this.model.isShared();
        },
    },

    ui: {
        'toggleEditMode': '[data-action="toggle-mode"]',
        'formAddSet': '[data-role="form-add-set"]',
        'name': 'input[name="name"]',
        'reset': '[data-action="reset"]',
        'shareButton': '[data-action="share"]',
        'boxInner': ' > *',
    },

    events: {
        'click': 'clickLink',
        'click @ui.toggleEditMode': 'toggleEditMode',
        'submit @ui.formAddSet': 'createSet',
        'reset @ui.formAddSet': 'cancelCreation',
        'keyup @ui.name': 'checkName',
        'keydown @ui.name': 'checkName',
        'change @ui.name': 'checkName',
        'click @ui.reset': 'cancelCreation',
        'click @ui.shareButton': 'onShareSet',
        'click @ui.boxInner': 'clickBoxOnRestriction',
    },

    modelEvents: {
        'change': 'render',
    },

    clickBoxOnRestriction: function(event){
        if (this.model.get('restricted') === true) {
            this.showRestrictionModal(this.model);
        }
    },

    clickLink: function(event) {
        if (this.model.get('restricted') === true) {
            event.preventDefault();

            return;
        }

        var link = $(event.currentTarget);

        if (!link.is('a')) {
            return;
        }

        if ($(event.target).is('[data-action="share"]')) {
            // if the data-action="share"-attribute was on the tag, cancel the a-tag-event and do nothing
            event.preventDefault();

            return;
        }

        event.preventDefault();

        if ($(event.currentTarget).attr('href')) {
            App.router.navigate($(event.currentTarget).attr('href'), {trigger: true});
        }
    },

    /**
     * Toggles the edit mode of the box
     * @param {object} event The event that has triggered the function
     * @return {void}
     */
    toggleEditMode: function(event) {
        if (this.model.get('restricted') === true) {
            event.preventDefault();

            return;
        }

        var mode  = this.$el.attr('data-mode');
        var empty = this.$el.attr('data-empty');

        if (empty === true || empty === 'true') {
            if (mode === 'view') {
                this.$el.addClass('box-stacked').removeClass('box-empty');
                this.$el.attr('data-mode', 'edit');
                this.$('[data-action="create"]').prop('disabled', true);
                this.$('input[name="name"]').focus();
            } else {
                this.$el.removeClass('box-stacked').addClass('box-empty');
                this.$el.attr('data-mode', 'view');
            }
        }
    },

    /**
     * Checks the name to enable/disable submit button
     * @param {object} event The event that has triggered the function
     */
    checkName: function(event) {
        this.$('[data-action="create"]').prop('disabled', $(event.currentTarget).val().length <= 0);
    },

    /**
     * Creates a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    createSet: function(event) {
        event.preventDefault();

        if (this.model.get('restricted') === true) {
            return;
        }

        var $curTarget = $(event.currentTarget);
        var name = $curTarget.find('[name="name"]').val();
        var catalog = this.model.collection.catalog;

        App.radio('collection:set').execute('create:set', catalog, name);

        // Disable edit mode
        $curTarget.find('[name="name"]').val('');
        this.toggleEditMode(event);
    },

    /**
     * Cancles the creation of a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    cancelCreation: function(event) {
        event.preventDefault();
        var $curTarget = $(event.currentTarget);
        this.$('input[name="name"]').val('');

        // Toggle mode
        this.toggleEditMode(event);
    },

    onShareSet: function(event) {
        if (this.model.get('restricted') === true) {
            event.preventDefault();

            return;
        }

        App.addModal(new ShareSetLayout({
            model: this.model,
        }), {
            additionalClassName: 'modal-left modal-medium modal-share-set',
        });
    },

    showRestrictionModal: function(model){
        var restrictionModalView = new RestrictionModalView({model: model});
        var options = {
            additionalClassName: 'modal-center modal-restriction',
            additionalBgClassName: 'light-bg',
        };
        App.addModal(restrictionModalView, options);
    },
});

module.exports = ListItemView;